import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { CaseRow, NewCaseDialog } from "@/components/portal/CasesComponents";

export default function Cases() {
  const [cases, setCases] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: "", case_type: "medical_malpractice", client_name: "", is_veteran: false, branch_of_service: "", summary: "", urgency: "standard" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const load = useCallback(() => api.get("/cases").then((r) => setCases(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/cases", f);
      toast.success("Case created");
      setOpen(false);
      setF({ title: "", case_type: "medical_malpractice", client_name: "", is_veteran: false, branch_of_service: "", summary: "", urgency: "standard" });
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="fade-in-up">
      <div className="flex justify-between items-end mb-8">
        <div><div className="text-caption text-[#B91C1C] mb-2">CASES</div><h1 className="font-serif text-3xl font-bold text-[#0A192F]">All Cases</h1></div>
        <button onClick={() => setOpen(true)} className="btn-navy px-5 py-2.5 text-[12px] uppercase tracking-widest inline-flex gap-2 items-center" data-testid="btn-new-case"><Plus className="w-4 h-4" />New Case</button>
      </div>
      <div className="card-federal">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-6 py-3 text-caption">Case #</th><th className="text-left px-6 py-3 text-caption">Title</th>
            <th className="text-left px-6 py-3 text-caption">Client</th><th className="text-left px-6 py-3 text-caption">Type</th>
            <th className="text-left px-6 py-3 text-caption">Status</th>
          </tr></thead>
          <tbody>
            {cases.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-500">No cases yet.</td></tr>}
            {cases.map((c) => <CaseRow key={c.id} c={c} />)}
          </tbody>
        </table>
      </div>

      {open && <NewCaseDialog f={f} set={set} onClose={() => setOpen(false)} onSubmit={submit} />}
    </div>
  );
}
